import React, { useState } from 'react';
import { Box, Typography, Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import usePhotoStyles from '../../styles/kozelDarkQuiz/photo';
import photo1 from '../../assets/images/kozel_dark_quiz/gallery/gallery-img-1.jpg';
import photo2 from '../../assets/images/kozel_dark_quiz/gallery/gallery-img-2.jpg';
import photo3 from '../../assets/images/kozel_dark_quiz/gallery/gallery-img-3.jpg';
import photo4 from '../../assets/images/kozel_dark_quiz/gallery/gallery-img-4.jpg';
import photo5 from '../../assets/images/kozel_dark_quiz/gallery/gallery-img-5.jpg';
import photo6 from '../../assets/images/kozel_dark_quiz/gallery/gallery-img-6.jpg';
import photo7 from '../../assets/images/kozel_dark_quiz/gallery/gallery-img-7.jpg';
import photo8 from '../../assets/images/kozel_dark_quiz/gallery/gallery-img-8.jpg';
import photo9 from '../../assets/images/kozel_dark_quiz/gallery/gallery-img-9.jpg';
import photo10 from '../../assets/images/kozel_dark_quiz/gallery/gallery-img-10.jpg';
    
const galleryImages = [
    { id: 1, src: photo1 },
    { id: 2, src: photo2 },
    { id: 3, src: photo3 },
    { id: 4, src: photo4 },
    { id: 5, src: photo5 },
    { id: 6, src: photo6 },
    { id: 7, src: photo7 },
    { id: 8, src: photo8 },
    { id: 9, src: photo9 },
    { id: 10, src: photo10 },
];

const Photo = () => {
    const classes = usePhotoStyles();
    const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null);

    const openLightbox = (index: number) => {
        setSelectedImageIndex(index);
    };

    const closeLightbox = () => {
        setSelectedImageIndex(null);
    };

    const goToPrevious = () => {
        if (selectedImageIndex !== null) {
            setSelectedImageIndex(selectedImageIndex === 0 ? galleryImages.length - 1 : selectedImageIndex - 1);
        }
    };

    const goToNext = () => {
        if (selectedImageIndex !== null) {
            setSelectedImageIndex(selectedImageIndex === galleryImages.length - 1 ? 0 : selectedImageIndex + 1);
        }
    };

    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (selectedImageIndex !== null) {
            switch (event.key) {
                case 'ArrowLeft':
                    goToPrevious();
                    break;
                case 'ArrowRight':
                    goToNext();
                    break;
                case 'Escape':
                    closeLightbox();
                    break;
            }
        }
    };

    return (
        <Box className={classes.container}>
            {/* Title Section */}
            <Box className={classes.titleSection}>
                <Typography variant="h1" className={classes.mainTitle}>
                    KOZEL <span className={classes.goldText}>INSPO</span> CORNER
                </Typography>
            </Box>

            {/* Photo Grid */}
            <Box className={classes.photoGrid}>
                {galleryImages.map((image, index) => (
                    <Box 
                        key={image.id} 
                        className={classes.photoItem}
                        onClick={() => openLightbox(index)}
                    >
                        <img 
                            src={image.src} 
                            className={classes.photoImage}
                        />
                        <Box className={classes.photoOverlay} />
                    </Box>
                ))}
            </Box>

            {/* Lightbox Modal */}
            <Modal
                open={selectedImageIndex !== null}
                onClose={closeLightbox}
                className={classes.modal}
                onKeyDown={handleKeyDown}
            >
                <Box className={classes.lightboxContainer}>
                    {selectedImageIndex !== null && (
                        <>
                            {/* Close Button */}
                            <IconButton 
                                className={classes.closeButton}
                                onClick={closeLightbox}
                            >
                                <CloseIcon />
                            </IconButton>

                            {/* Previous Button */}
                            <IconButton 
                                className={`${classes.navButton} ${classes.prevButton}`}
                                onClick={goToPrevious}
                            >
                                <ArrowBackIosIcon />
                            </IconButton>

                            {/* Image */}
                            <img 
                                src={galleryImages[selectedImageIndex].src}
                                className={classes.lightboxImage}
                            />

                            {/* Next Button */}
                            <IconButton 
                                className={`${classes.navButton} ${classes.nextButton}`}
                                onClick={goToNext}
                            >
                                <ArrowForwardIosIcon />
                            </IconButton>

                            {/* Image Counter */}
                            <Box className={classes.imageCounter}>
                                {selectedImageIndex + 1} / {galleryImages.length}
                            </Box>
                        </>
                    )}
                </Box>
            </Modal>
        </Box>
    );
};

export default Photo;